const store: Record<string, any> = {};

export function setStoreItem(key: string, value: any) {
  store[key] = value;
}

export function getStoreItem(key: string, defaultValue: any = {}) {
  return store[key] || defaultValue;
}
